import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { restApiFormData } from '../../api/axios';
import { API_ENDPOINTS } from '../../api/constants';
import toast from 'react-hot-toast';

const initialState = {
    positions: [],
    bulkUpdatePositions: [],
};

export const setBulkUpdatePositionIds = createAsyncThunk(
    'bulkUpdatePositionStatuses',
    (data = {}, { rejectWithValue }) =>
        restApiFormData
            .post(API_ENDPOINTS.BULK_UPDATE_POSITION_STATUSES, data)
            .then((res) => {
                if (res?.data?.status !== 'SUCCESS') {
                    return rejectWithValue(res?.data);
                }
                return res.data;
            })
            .catch((error) => {
                if (error?.response?.status === 400) toast.error(error?.response?.data?.message);
                else toast.error(error.message);
                console.log(error);
            }),
);

const positions = createSlice({
    name: 'positions',
    initialState: {
        selectedPositions: [],
        positions: {
            count: 0,
            data: [],
            states: {},
            extendedDef: {},
        },
    },
    reducers: {
        updatePositions(state, action) {
            const {
                positionInstanceList = [],
                statusWiseStats = {},
                positionInstanceCount = 0,
                totalCount = 0,
                statuses,
                extendedDef = {},
            } = action.payload;
            state.positions.data = positionInstanceList;
            state.positions.count = positionInstanceCount || totalCount;
            state.positions.states = statusWiseStats;
            state.positions.statusList = statuses;
            state.positions.extendedDef = extendedDef;
        },
        resetSelectedPositions(state) {
            state.selectedPositions = [];
        },
        updateSelectedPositions(state, action) {
            const { isChecked, rowId } = action.payload;

            if (isChecked) {
                state.selectedPositions.push(rowId);
                return;
            }
            state.selectedPositions = state.selectedPositions.filter((selectedRow) => selectedRow !== rowId);
        },
        updateAllSelectedPositions(state, action) {
            const { isChecked } = action.payload;
            state.selectedPositions = [];
            if (isChecked) {
                state.positions.data.map((row) => state.selectedPositions.push(row['id']));
                return;
            }
            state.selectedPositions = [];
        },
        setBulkUpdatePositionIds(state, action) {
            state.bulkUpdatePositions = action.payload;
        },
    },
});

export const { updatePositions, updateSelectedPositions, resetSelectedPositions, updateAllSelectedPositions } =
    positions.actions;

export default positions.reducer;
